/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ScheduledAIWebCallEventType =
  (typeof ScheduledAIWebCallEventType)[keyof typeof ScheduledAIWebCallEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledAIWebCallEventType = {
  SCHEDULED: 'SCHEDULED',
  RESCHEDULED: 'RESCHEDULED',
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
